import React, { useCallback, useEffect, useState } from "react";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/Endpoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import moment from "moment";
import TableActionButton from "../Reusable/TableActionButton";
import { useForm } from "react-hook-form";
import { AccessControl } from "@careinfo/permission-required";
import Card from "../Reusable/Card";
import NoticeFilter from "./NoticeFilter";
import { useSessionStorage } from "@uidotdev/usehooks";
import { hasValues } from "../../utils/hasValues";
import SwitchButton from "../Reusable/SwitchButton";
import { useNavigate } from "react-router-dom";

export interface IFilter {
  user: string | null;
  branch: string | null;
  created__range: string | null;
}

const NoticeList = (props: any) => {
  const { handleIsActive } = props;
  const navigate=useNavigate()
  const [localState, handleSetState] = useSessionStorage<IFilter>(
    "ticket-filter",
    {
      user: null,
      branch: null,
      created__range: null,
    }
  );
  const {
    register,
    setValue,
    getValues,
    watch,
    setError,
    reset,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<IFilter>({
    defaultValues: async () => {
      return {
        user: localState.user ?? null,
        branch: localState.branch ?? null,
        created__range: localState?.created__range ?? null,
      };
    },
  });
  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));

  const defaultColumns = [
    {
      id:"title",
      header: "Title",
      accessorKey: "title",
      cell: NACell,
    },
    {
      id: "created",
      header: "Created",
      accessorKey: "created",
      cell: ({ row, getvalue }: any) => {
        return (
          <div>
            <p className={tw`text-xs text-gray-500 `}>
              {moment(row?.original?.created).format("YY-MM-DD HH:mm:ss")}
            </p>
          </div>
        );
      },
    },
    {
      id:"type ",
      header: "Type",
      accessorKey: "type",
      cell: NACell,
    },
    {
      id: "theme",
      header: "Theme",
      accessorKey: "theme",
      cell: NACell,
    },
    {
      id:"active",
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}> 
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
  ];

  const filterParams = watch();
  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]);

  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  const handleFilterReset = () => {
    reset({
      user: null,
      branch: null,
      created__range: null,
    });
  };

  return (
    <>

       {/* <AccessControl
        children={
          <Card
            title="Filters"
            onClick={() => setFilterVisiable(!isFilterVisible)}
          >
            <NoticeFilter
              register={register}
              getValues={getValues}
              watch={watch}
              errors={errors}
              clearErrors={clearErrors}
              setValue={setValue}
              reset={handleFilterReset}
              control={control}
              isFilterVisible={isFilterVisible}
              // handleFilterReset={handleFilterReset}
            />
          </Card>
        }
        allowedPermissions={["can_edit_filter"]}
      /> */}
      <DataTable
        url={APIS.NOTICE}
        queryKey={"notice"}
        columns={defaultColumns}
        addNewPagePath={"/create"}
        tableName={"Notice"}
        isUpload={false}
        params={params()}
        onRowClick={(row:any)=> navigate(`edit/${row?.original?.id}`)}
      />
    </>
  );
};

export default NoticeList;
